export * from './lib/vehicle-assignment.service';
